export class TherapyEntity {
  id: number;
  name: string;
  constructor(therapyEntity: object) {
    Object.assign(this, therapyEntity);
  }
}
